(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function closeVideoDialog(dialog) {
    if (!dialog) return;
    var iframe = dialog.querySelector('iframe');
    var video = dialog.querySelector('video');
    if (iframe) iframe.src = '';
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(function () {});
    }
    if (dialog.open) dialog.close();
  }

  function openVideoDialog(trigger) {
    var root = trigger.closest('.jci-twin-v2') || document;
    var dialog = root.querySelector('[data-twin-video-dialog]');
    if (!dialog) return;
    var iframe = dialog.querySelector('iframe[data-twin-video-src]');
    var video = dialog.querySelector('video');
    if (!iframe && !video) return;
    if (iframe) iframe.src = iframe.getAttribute('data-twin-video-src') || '';
    dialog.showModal();
    if (video) {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }
  }

  function showGalleryMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll('[data-twin-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
    });
    gallery.querySelectorAll('[data-twin-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(mediaId));
    });
    // Desktop slides are display:none until active, so the spin starts on its first show.
    if (String(mediaId) === 'spin') {
      var spin = gallery.querySelector('#sirv-spin');
      if (spin && spin.getAttribute('data-twin-spin-started') !== 'true') startGallerySpin(spin);
      else if (window.Sirv && window.Sirv.refresh) window.Sirv.refresh();
    }
    // Scroll the containers themselves: scrollIntoView also drags the page
    // sideways when anything else on it overflows.
    var active = gallery.querySelector('[data-twin-slide].is-active');
    var track = gallery.querySelector('.jci-twin-gallery__track');
    if (active && track && window.innerWidth <= 767) {
      track.scrollTo({ left: active.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    var activeThumb = gallery.querySelector('[data-twin-thumb].is-active');
    var rail = gallery.querySelector('[data-twin-thumbs-scroller]');
    if (activeThumb && rail && window.innerWidth > 767) {
      var pad = activeThumb.offsetHeight;
      var top = activeThumb.offsetTop;
      if (top < rail.scrollTop + pad) {
        rail.scrollTo({ top: top - pad, behavior: 'smooth' });
      } else if (top + pad > rail.scrollTop + rail.clientHeight - pad) {
        rail.scrollTo({ top: top + pad * 2 - rail.clientHeight, behavior: 'smooth' });
      }
    }
  }

  function thumbMetrics(scroller) {
    var first = scroller.querySelector('[data-twin-thumb]');
    var size = first ? first.offsetHeight : 74;
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.rowGap || styles.gap) || 12;
    var inset = parseFloat(styles.paddingTop) || size;
    return { size: size, gap: gap, inset: inset, step: size + gap };
  }

  // The pinned media (product featured image) and the 360 spin lead for every
  // colour, then the selected colour's media, then the shared shots; other
  // colours are hidden.
  function filterGalleryGroup(gallery, group) {
    if (!group) return;
    var containers = [gallery.querySelector('[data-twin-thumbs-scroller]'), gallery.querySelector('.jci-twin-gallery__track')];
    var visibleThumbs = 0;
    containers.forEach(function (container) {
      if (!container) return;
      var items = Array.prototype.slice.call(container.querySelectorAll('[data-twin-slide], [data-twin-thumb]'));
      var groupOf = function (item) { return item.getAttribute('data-twin-group') || ''; };
      var isPinned = function (item) { return item.hasAttribute('data-twin-pinned') || item.hasAttribute('data-twin-spin'); };
      var ordered = items.filter(isPinned)
        .concat(items.filter(function (item) { return !isPinned(item) && groupOf(item) === group; }))
        .concat(items.filter(function (item) { return !isPinned(item) && groupOf(item) === ''; }));
      items.forEach(function (item) {
        var show = isPinned(item) || groupOf(item) === group || groupOf(item) === '';
        // The spin slot stays hidden until the Sirv spin has been moved into it.
        if (item.hasAttribute('data-twin-spin')) show = item.getAttribute('data-twin-spin') === 'ready';
        item.hidden = !show;
        if (show && item.hasAttribute('data-twin-thumb')) visibleThumbs += 1;
      });
      ordered.forEach(function (item) { container.appendChild(item); });
    });
    var more = gallery.querySelector('[data-twin-thumbs-more]');
    if (more) more.hidden = visibleThumbs <= 5;
    syncThumbsMore(gallery);
  }

  function remainingThumbs(scroller) {
    var thumbs = scroller.querySelectorAll('[data-twin-thumb]:not([hidden])');
    var metrics = thumbMetrics(scroller);
    var viewBottom = scroller.scrollTop + scroller.clientHeight - metrics.inset;
    var count = 0;
    thumbs.forEach(function (thumb) {
      if (thumb.offsetTop + thumb.offsetHeight - 8 > viewBottom) count += 1;
    });
    return count;
  }

  function syncThumbsMore(gallery) {
    var scroller = gallery.querySelector('[data-twin-thumbs-scroller]');
    var more = gallery.querySelector('[data-twin-thumbs-more]');
    if (!scroller || !more) return;
    var leftover = remainingThumbs(scroller);
    more.hidden = leftover <= 0;
    more.textContent = leftover > 0 ? '+' + leftover : '';
    more.setAttribute('aria-label', leftover > 0 ? 'Show ' + leftover + ' more images' : 'All images visible');
  }

  // (Re)start the Sirv spin once its box has a size: an instance created while
  // the element was hidden keeps a zero-size canvas.
  function startGallerySpin(spin) {
    var tries = 0;
    (function attempt() {
      if (window.Sirv && window.Sirv.start) {
        if (window.Sirv.getInstance && window.Sirv.getInstance(spin) && window.Sirv.stop) window.Sirv.stop(spin);
        window.Sirv.start(spin);
        spin.setAttribute('data-twin-spin-started', 'true');
        return;
      }
      if (tries++ < 40) window.setTimeout(attempt, 250);
    })();
  }

  // The 360 spin is rendered by the Magic Zoom app inside the legacy gallery,
  // which V2 hides. Move it into the gallery's spin slot; on mobile the slot is
  // part of the visible track, so start it right away.
  function attachGallerySpin(gallery) {
    var slide = gallery.querySelector('[data-twin-slide][data-twin-spin]');
    var thumb = gallery.querySelector('[data-twin-thumb][data-twin-spin]');
    var spin = document.querySelector('#sirv-spin');
    if (!slide || !thumb || !spin || slide.contains(spin)) return;
    slide.appendChild(spin);
    slide.setAttribute('data-twin-spin', 'ready');
    thumb.setAttribute('data-twin-spin', 'ready');
    slide.hidden = false;
    thumb.hidden = false;
    if (slide.offsetWidth > 0) startGallerySpin(spin);
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-twin-gallery]');
    if (!gallery) return;
    attachGallerySpin(gallery);

    var scroller = gallery.querySelector('[data-twin-thumbs-scroller]');
    var more = gallery.querySelector('[data-twin-thumbs-more]');
    if (scroller && more) {
      more.addEventListener('click', function () {
        var metrics = thumbMetrics(scroller);
        var page = Math.max(metrics.step * 5, scroller.clientHeight - metrics.inset * 2);
        scroller.scrollBy({ top: page, behavior: 'smooth' });
      });
      scroller.addEventListener('scroll', function () {
        syncThumbsMore(gallery);
      });
      if (window.ResizeObserver) {
        var stage = gallery.querySelector('.jci-twin-gallery__stage');
        var observer = new ResizeObserver(function () {
          syncThumbsMore(gallery);
        });
        observer.observe(scroller);
        if (stage) observer.observe(stage);
      }
      window.addEventListener('resize', function () {
        syncThumbsMore(gallery);
      });
      requestAnimationFrame(function () {
        syncThumbsMore(gallery);
      });
    }

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-twin-thumb]');
      if (!thumb) return;
      showGalleryMedia(gallery, thumb.getAttribute('data-media-id'));
    });

    var variantMap = [];
    var variantJson = root.querySelector('[data-twin-gallery-variants]');
    if (variantJson) {
      try {
        variantMap = JSON.parse(variantJson.textContent || '[]');
      } catch (err) {
        variantMap = [];
      }
    }

    var selector = root.querySelector('.original-selector');
    function applyVariant() {
      var match = variantMap.filter(function (item) {
        return String(item.id) === String(selector.value);
      })[0];
      if (!match) return;
      filterGalleryGroup(gallery, match.group);
      var mediaId = match.mediaId;
      if (!mediaId) {
        var first = gallery.querySelector('[data-twin-slide]:not([hidden])');
        mediaId = first && first.getAttribute('data-media-id');
      }
      if (mediaId) showGalleryMedia(gallery, mediaId);
      // The stage re-renders after the swap; recount the rail once it settles.
      window.setTimeout(function () { syncThumbsMore(gallery); }, 400);
    }
    if (selector) {
      selector.addEventListener('change', applyVariant);
      // On load only the colour's media is filtered in; the lead photo stays unless the URL picks a variant.
      if (selector.value && /[?&]variant=/.test(window.location.search)) {
        applyVariant();
      } else if (selector.value) {
        var initial = variantMap.filter(function (item) { return String(item.id) === String(selector.value); })[0];
        if (initial) filterGalleryGroup(gallery, initial.group);
      }
    }
  }

  function openTwinReviews(event) {
    if (event) event.preventDefault();
    var reviews = document.querySelector('#yotpo-reviews-main-widget, .yotpo-reviews-main-widget, #shopify-product-reviews');
    if (reviews) {
      window.scrollTo({ top: reviews.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
      return;
    }
    var triggers = document.querySelectorAll(
      '.yotpo-sr-bottom-line-button, .yotpo-bottom-line-scroll-panel button, [class*="yotpo-reviews-star-ratings-widget"] button, .yotpo-widget-instance a, .yotpo-widget-instance button'
    );
    for (var i = 0; i < triggers.length; i += 1) {
      var trigger = triggers[i];
      if (!trigger || trigger.closest('.jci-twin-rating')) continue;
      trigger.click();
      return;
    }
    var drawer = document.querySelector('.yotpo-reviews-summary-drawer-container, [class*="yotpo-reviews-summary-drawer"]');
    if (drawer) {
      drawer.removeAttribute('hidden');
      drawer.style.display = 'block';
      drawer.classList.add('is-open');
      return;
    }
    var widget = document.querySelector('#shopify-product-reviews, .yotpo.yotpo-main-widget, [data-yotpo-instance-id]');
    if (widget && widget.scrollIntoView) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function syncColorLabel(root) {
    var selector = root.querySelector('.option-selector--swatch');
    if (!selector) return;
    var label = selector.querySelector('.label');
    if (!label) return;
    var selected = selector.querySelector('.opt-btn:checked + .opt-label .opt-label__text');
    var value = selected ? selected.textContent.trim() : '';
    var key = label.querySelector('.jci-twin-color__key');
    var val = label.querySelector('.jci-twin-color__value');
    if (!key || !val) {
      label.innerHTML = '<span class="jci-twin-color__key">Color</span><span class="jci-twin-color__value"></span>';
      val = label.querySelector('.jci-twin-color__value');
    }
    if (val) val.textContent = value;
  }

  function colorControl(scope, value) {
    if (!scope || !value) return null;
    var safe = value.replace(/"/g, '\\"');
    return (
      scope.querySelector('input[type="radio"][value="' + safe + '"]') ||
      scope.querySelector('[data-value="' + safe + '"]') ||
      scope.querySelector('[data-option-value="' + safe + '"]') ||
      scope.querySelector('label[for][title="' + safe + '"]')
    );
  }

  function isControlActive(control) {
    if (!control) return false;
    if (control.checked) return true;
    return (
      control.getAttribute('aria-checked') === 'true' ||
      control.getAttribute('aria-selected') === 'true' ||
      control.classList.contains('is-active') ||
      control.classList.contains('selected')
    );
  }

  function syncSticky(root) {
    var sticky = root.querySelector('[data-twin-sticky]');
    if (!sticky) return;
    var scope = root.querySelector('.jci-twin-buy') || root;
    var current = '';
    sticky.querySelectorAll('[data-twin-sticky-swatch]').forEach(function (swatch) {
      var value = swatch.getAttribute('data-twin-sticky-swatch');
      var active = isControlActive(colorControl(scope, value));
      swatch.classList.toggle('is-active', active);
      if (active) current = value;
    });
    var label = sticky.querySelector('[data-twin-sticky-color]');
    if (label && current) label.textContent = current;

    // Mirror the sold-out state: the theme flags the product container, not the button.
    var atc = sticky.querySelector('[data-twin-sticky-atc]');
    if (atc) {
      var soldOut = !!(scope.closest('.variant-status--unavailable') || scope.querySelector('.variant-status--unavailable'));
      if (!atc.hasAttribute('data-twin-sticky-label')) atc.setAttribute('data-twin-sticky-label', atc.textContent.trim());
      atc.disabled = soldOut;
      atc.textContent = soldOut ? 'Sold out' : atc.getAttribute('data-twin-sticky-label');
    }
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-twin-sticky]');
    if (!sticky) return;
    var scope = root.querySelector('.jci-twin-buy') || root;
    // The purchase form, not the first cart form: the Shop Pay instalments row by the price is one too.
    var form = scope.querySelector('form.product-purchase-form');
    var mainAtc = form ? form.querySelector('[name="add"], button[type="submit"]') : null;
    var anchor = mainAtc || form || scope;
    if (!anchor) return;

    function setVisible(visible) {
      if (sticky.hidden === !visible) return;
      sticky.hidden = !visible;
      sticky.classList.toggle('is-visible', visible);
    }

    // Waggle V2: the bar shows in the first view and after the selections, never
    // while the shopper is choosing. "Choosing" = the zone from the canopy picker
    // to the summary crosses the middle of the screen.
    var zoneStart = root.querySelector('[data-wagon-config]');
    var zoneEnd = root.querySelector('[data-wagon-summary]') || root.querySelector('[data-wagon-addons]');
    if (zoneStart && zoneEnd) {
      // Two rect reads per scroll event: cheap enough to skip any throttling.
      var syncStickyZone = function () {
        var middle = window.innerHeight / 2;
        var top = zoneStart.getBoundingClientRect().top;
        var bottom = zoneEnd.getBoundingClientRect().bottom;
        setVisible(!(top <= middle && bottom >= middle));
      };
      window.addEventListener('scroll', syncStickyZone, { passive: true });
      window.addEventListener('resize', syncStickyZone);
      syncStickyZone();
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      });
      observer.observe(anchor);
    }

    sticky.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-twin-sticky-swatch]');
      if (swatch) {
        event.preventDefault();
        var control = colorControl(scope, swatch.getAttribute('data-twin-sticky-swatch'));
        if (control) control.click();
        window.setTimeout(function () { syncSticky(root); }, 120);
        return;
      }
      if (!event.target.closest('[data-twin-sticky-atc]')) return;
      event.preventDefault();
      if (mainAtc) {
        mainAtc.click();
      } else if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }
    });

    scope.addEventListener('change', function () {
      window.setTimeout(function () { syncSticky(root); }, 60);
    });

    syncSticky(root);
    // The theme flags the sold-out variant during its own init; read it once more after that.
    window.setTimeout(function () { syncSticky(root); }, 500);
  }

  // Figma puts reviews and awards after the buy column on mobile, but after the
  // gallery on desktop, so the two nodes swap parents at the 767px breakpoint.
  // Waggle V2: keep the right canopy radio and the label in step with the visible swatch
  // One add-to-cart for our own buttons: same endpoint and the same follow-up as the theme.
  function postCartItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  function announceCartAdd() {
    var theme = window.theme || {};
    if (theme.settings && theme.settings.after_add_to_cart === 'page') {
      window.location = theme.routes.cart_url;
      return;
    }
    // The cart drawer refetches itself and opens on this event.
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
  }

  // Waggle V2 with the canopy bundle: the buy button adds the bundle variant for the picked
  // colour (wagon + 2 canopies as one Shopify Bundles line) plus the ticked accessory lines.
  // The theme's own submit can't: it only accepts the wagon's own variants.
  function initWagonBundleAtc(root) {
    var config = root.querySelector('[data-wagon-config][data-canopy-bundle]');
    if (!config) return;
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form.product-purchase-form') || !root.contains(form)) return;
      var picked = config.querySelector('[data-config-color="canopy"]:checked');
      var bundleId = picked && picked.getAttribute('data-bundle-variant');
      if (!bundleId) return;
      event.preventDefault();
      event.stopPropagation();
      var quantities = {};
      [bundleId].concat(Array.prototype.map.call(root.querySelectorAll('input[name^="addon["]:checked'), function (input) {
        return input.value;
      })).forEach(function (id) {
        if (id) quantities[id] = (quantities[id] || 0) + 1;
      });
      var items = Object.keys(quantities).map(function (id) {
        return { id: parseInt(id, 10), quantity: quantities[id] };
      });
      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.classList.add('btn--in-progress');
        button.disabled = true;
      }
      postCartItems(items).then(announceCartAdd).catch(function (error) {
        var theme = window.theme || {};
        if (theme.showQuickPopup && window.jQuery && button) theme.showQuickPopup(error.message, window.jQuery(button), 'error');
      }).then(function () {
        if (!button) return;
        button.classList.remove('btn--in-progress');
        button.disabled = false;
      });
    }, true);
  }

  // Same money format as the theme's own prices (this store shows whole dollars);
  // a sale price keeps its cents ($35.40) so the summary matches the cart (BFCM 2026, CNV-6876).
  function configMoney(cents) {
    var theme = window.theme || {};
    if (!(theme.Shopify && theme.money_format)) return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (theme.money_format.indexOf('no_decimals') === -1) return theme.Shopify.formatMoney(cents, theme.money_format);
    var frac = Math.abs(cents) % 100;
    var out = theme.Shopify.formatMoney(cents - frac, theme.money_format);
    return frac ? out + '.' + (frac < 10 ? '0' : '') + frac : out;
  }

  // Waggle V2 first screen: canopy colour above the buy button, basket and
  // snack tray as cards below it, one live summary and one live image for all
  // of it. Every choice is an addon input; the hidden mirror inputs are what
  // turns "dual" into quantity two in the cart. A card's ADD is a master
  // checkbox: while it is off, none of that card's inputs are checked.
  function initWagonConfig(root) {
    var config = root.querySelector('[data-wagon-config]');
    if (!config) return;
    var summary = root.querySelector('[data-wagon-summary]');
    var gallery = root.querySelector('[data-twin-gallery]');
    var cdn = (config.getAttribute('data-canopy-base') || '').replace('wagon-base.png', '');
    var picked = { canopy: '1', basket: '1' };

    function masterOf(group) {
      return root.querySelector('[data-config-master="' + group + '"]');
    }

    function isAdded(group) {
      var master = masterOf(group);
      return !!(master && master.checked);
    }

    function setAdded(group, on) {
      var master = masterOf(group);
      if (!master) return;
      master.checked = on;
      var button = root.querySelector('[data-twin-addon-add="' + master.id + '"]');
      if (button) {
        button.textContent = on ? 'Added' : 'Add';
        button.classList.toggle('is-added', on);
      }
    }

    function countOf(group) {
      if (group === 'canopy') return 'dual';
      if (!isAdded(group)) return 'none';
      var input = root.querySelector('[data-config-count="' + group + '"]:checked');
      return input ? input.value : 'single';
    }

    function priceOf(group) {
      var input = root.querySelector('[data-config-count="' + group + '"]:checked');
      return input ? parseInt(input.getAttribute('data-config-price'), 10) || 0 : 0;
    }

    function colorInput(group, index) {
      return root.querySelector('[data-config-color="' + group + '"][data-config-index="' + index + '"]');
    }

    function applyGroup(group) {
      var count = countOf(group);
      var colors = root.querySelectorAll('[data-config-color="' + group + '"]');
      var mirrors = root.querySelectorAll('[data-config-mirror="' + group + '"]');
      if (colors.length) {
        colors.forEach(function (input) {
          input.checked = count !== 'none' && input.getAttribute('data-config-index') === picked[group];
          // The swatch keeps its ring while the card is off, so the row still reads as a choice.
          var swatch = root.querySelector('label[for="' + input.id + '"]');
          if (swatch) swatch.classList.toggle('is-picked', input.getAttribute('data-config-index') === picked[group]);
        });
        mirrors.forEach(function (input) {
          input.checked = count === 'dual' && input.getAttribute('data-config-index') === picked[group];
        });
      } else {
        // Snack tray has one variant, so the two hidden inputs are the two sides.
        mirrors.forEach(function (input, index) {
          input.checked = count === 'dual' || (count === 'single' && index === 0);
        });
      }
      return count;
    }

    function labelFor(group, count) {
      if (count === 'none') return 'None';
      var name = count.charAt(0).toUpperCase() + count.slice(1);
      var color = colorInput(group, picked[group]);
      if (!color) return name;
      if (group === 'canopy') return color.getAttribute('data-config-label') || '';
      return name + ' - ' + (color.getAttribute('data-config-label') || '');
    }

    function summaryRow(group) {
      return summary && summary.querySelector('[data-summary-row="' + group + '"]');
    }

    function syncSummary(counts) {
      if (!summary) return;
      var total = parseInt(config.getAttribute('data-base-price'), 10) || 0;
      // Regular prices of the same picks: the gap is the "$X saved" pill next to the total.
      var was = parseInt(config.getAttribute('data-base-was'), 10) || total;
      ['canopy', 'basket', 'snack'].forEach(function (group) {
        var row = summaryRow(group);
        if (!row) return;
        var meta = row.querySelector('[data-summary-meta]');
        var price = row.querySelector('[data-summary-price]');
        row.hidden = counts[group] === 'none';
        if (meta) meta.textContent = labelFor(group, counts[group]);
        if (price && !row.hidden) {
          var amount = priceOf(group);
          total += amount;
          was += wasOf(group) || amount;
          price.textContent = configMoney(amount);
        }
      });
      var addons = syncSummaryAddons();
      total += addons.total;
      was += addons.was;
      var totalNode = summary.querySelector('[data-summary-total]');
      if (totalNode) totalNode.textContent = configMoney(total);
      var savedNode = summary.querySelector('[data-summary-saved]');
      if (savedNode) {
        savedNode.hidden = was <= total;
        savedNode.textContent = configMoney(was - total) + ' saved';
      }
    }

    function wasOf(group) {
      var input = root.querySelector('[data-config-count="' + group + '"]:checked');
      return input ? parseInt(input.getAttribute('data-config-was'), 10) || 0 : 0;
    }

    // Plain accessory cards (bug net, rain cover) add a summary row while ticked.
    function syncSummaryAddons() {
      var template = summary && summary.querySelector('[data-summary-addon-template]');
      if (!template) return { total: 0, was: 0 };
      summary.querySelectorAll('[data-summary-addon]').forEach(function (row) {
        row.remove();
      });
      var total = 0;
      var was = 0;
      root.querySelectorAll('[data-addon-card]').forEach(function (card) {
        var input = card.querySelector('input[name^="addon["]');
        if (!input || !input.checked) return;
        var amount = parseInt(card.getAttribute('data-addon-price'), 10) || 0;
        total += amount;
        was += parseInt(card.getAttribute('data-addon-was'), 10) || amount;
        var row = template.cloneNode(true);
        row.removeAttribute('data-summary-addon-template');
        row.setAttribute('data-summary-addon', '');
        row.hidden = false;
        row.querySelector('[data-summary-meta]').textContent = card.getAttribute('data-addon-title') || 'Accessory';
        row.querySelector('[data-summary-price]').textContent = configMoney(amount);
        template.parentNode.insertBefore(row, template);
      });
      return { total: total, was: was };
    }

    // Every change rebuilds the stage image, which is the "gallery swap" the design asks for.
    function showComposite() {
      var track = gallery && gallery.querySelector('.jci-twin-gallery__track');
      var scroller = gallery && gallery.querySelector('[data-twin-thumbs-scroller]');
      if (!track) return;
      var layers = '<img src="' + config.getAttribute('data-canopy-base') + '" alt="">' +
        '<img data-config-layer="basket-left" src="" alt="" hidden>' +
        '<img data-config-layer="basket-right" src="" alt="" hidden>' +
        '<img data-config-layer="canopy-left" src="" alt="" hidden>' +
        '<img data-config-layer="canopy-right" src="" alt="" hidden>' +
        '<img data-config-layer="snack" src="" alt="" hidden>';
      var slide = track.querySelector('[data-media-id="canopy"]');
      if (!slide) {
        slide = document.createElement('figure');
        slide.className = 'jci-twin-gallery__slide jci-twin-gallery__slide--canopy';
        slide.setAttribute('data-twin-slide', '');
        slide.setAttribute('data-media-id', 'canopy');
        // Award badges sit on the build image only, as on the Twin and V3 photos (Kelsey 11/3).
        var awards = config.getAttribute('data-awards-src');
        slide.innerHTML = layers + (awards ? '<img class="jci-wagon-awards" src="' + awards + '" alt="Best of Babylist, Good Housekeeping Parenting Awards winner">' : '');
        track.insertBefore(slide, track.firstChild);
      }
      var thumb = scroller && scroller.querySelector('[data-media-id="canopy"]');
      if (scroller && !thumb) {
        thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'jci-twin-gallery__thumb jci-twin-gallery__thumb--canopy';
        thumb.setAttribute('data-twin-thumb', '');
        thumb.setAttribute('data-media-id', 'canopy');
        thumb.setAttribute('aria-label', 'View your waggle');
        thumb.innerHTML = layers;
        scroller.insertBefore(thumb, scroller.firstChild);
      }

      var canopy = colorInput('canopy', picked.canopy);
      var basket = colorInput('basket', picked.basket);
      var basketCount = countOf('basket');
      var snackCount = countOf('snack');
      var sources = {
        'canopy-left': canopy && canopy.getAttribute('data-config-img-left'),
        'canopy-right': canopy && canopy.getAttribute('data-config-img-right'),
        'basket-left': basketCount !== 'none' && basket ? basket.getAttribute('data-config-img-left') : null,
        'basket-right': basketCount === 'dual' && basket ? basket.getAttribute('data-config-img-right') : null,
        'snack': snackCount === 'none' ? null : cdn + 'snack-tray-' + (snackCount === 'dual' ? 'both' : 'left') + '.png'
      };
      [slide, thumb, root.querySelector('[data-sticky-build]')].forEach(function (host) {
        if (!host) return;
        Object.keys(sources).forEach(function (key) {
          var layer = host.querySelector('[data-config-layer="' + key + '"]');
          if (!layer) return;
          if (sources[key]) {
            if (layer.getAttribute('src') !== sources[key]) layer.src = sources[key];
            layer.hidden = false;
          } else {
            layer.hidden = true;
          }
        });
      });
      showGalleryMedia(gallery, 'canopy');
    }

    // Waggle has no colour variants, so the sticky bar mirrors the canopy picker
    function syncStickyCanopy() {
      var sticky = root.querySelector('[data-twin-sticky]');
      var buy = sticky && sticky.querySelector('.jci-twin-sticky__buy');
      if (!buy) return;
      var block = sticky.querySelector('[data-twin-sticky-canopy]');
      if (!block) {
        block = document.createElement('div');
        block.className = 'jci-twin-sticky__colors';
        block.setAttribute('data-twin-sticky-canopy', '');
        block.innerHTML = '<span class="jci-twin-sticky__color-label">Canopy color</span>' +
          '<span class="jci-twin-sticky__color-value"></span>' +
          '<div class="jci-twin-sticky__swatches"></div>';
        buy.insertBefore(block, buy.firstChild);
        var swatches = block.querySelector('.jci-twin-sticky__swatches');
        config.querySelectorAll('[data-config-color="canopy"]').forEach(function (input) {
          var label = config.querySelector('label[for="' + input.id + '"]');
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'jci-twin-sticky__swatch';
          button.setAttribute('data-canopy-sticky', input.getAttribute('data-config-index'));
          button.setAttribute('aria-label', input.getAttribute('data-config-label') || '');
          if (label && label.getAttribute('data-swatch')) button.setAttribute('data-swatch', label.getAttribute('data-swatch'));
          button.innerHTML = '<span class="jci-twin-sticky__swatch-fill" aria-hidden="true"></span>';
          swatches.appendChild(button);
        });
        block.addEventListener('click', function (event) {
          var button = event.target.closest('[data-canopy-sticky]');
          if (!button) return;
          event.preventDefault();
          var input = colorInput('canopy', button.getAttribute('data-canopy-sticky'));
          if (!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      var current = colorInput('canopy', picked.canopy);
      block.querySelector('.jci-twin-sticky__color-value').textContent = current ? current.getAttribute('data-config-label') : '';
      block.querySelectorAll('[data-canopy-sticky]').forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-canopy-sticky') === picked.canopy);
      });
    }

    function sync(swapGallery) {
      var counts = {};
      // Bundles read the picked colours from here.
      config.setAttribute('data-config-picked-canopy', picked.canopy);
      config.setAttribute('data-config-picked-basket', picked.basket);
      ['canopy', 'basket', 'snack'].forEach(function (group) {
        counts[group] = applyGroup(group);
        var value = root.querySelector('[data-config-value="' + group + '"]');
        if (value) value.textContent = labelFor(group, counts[group]);
      });
      syncSummary(counts);
      syncStickyCanopy();
      if (swapGallery) showComposite();
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      var colorGroup = target.getAttribute('data-config-color');
      var countGroup = target.getAttribute('data-config-count');
      var masterGroup = target.getAttribute('data-config-master');
      var ours = colorGroup || countGroup || masterGroup || target.closest('[data-addon-card]');
      if (!ours) return;
      // Radios also announce a programmatic uncheck (the cart reset): only a checked one is a choice.
      if (colorGroup && target.checked) {
        picked[colorGroup] = target.getAttribute('data-config-index');
        // The card's ADD re-ticks the master and follows its value: keep it on this colour.
        var colorMaster = masterOf(colorGroup);
        if (colorMaster) colorMaster.value = target.value;
        if (colorGroup !== 'canopy' && !isAdded(colorGroup)) setAdded(colorGroup, true);
      } else if (countGroup && target.checked && !isAdded(countGroup)) {
        setAdded(countGroup, true);
      } else if (masterGroup && target.checked && target.value) {
        // The details dialog may have picked a colour for the card: follow it.
        var match = root.querySelector('[data-config-color="' + masterGroup + '"][value="' + target.value + '"]');
        if (match) picked[masterGroup] = match.getAttribute('data-config-index');
      }
      sync(!!(colorGroup || countGroup || masterGroup));
    });

    // The card's ADD button is handled by the shared Twin handler; settle after it ran.
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-wagon-addons] [data-twin-addon-add]')) {
        window.setTimeout(function () { sync(true); }, 0);
      }
    });

    // After an add to cart the theme clears the accessory rows; the masters follow.
    document.addEventListener('theme:cartchanged', function () {
      ['basket', 'snack'].forEach(function (group) { setAdded(group, false); });
      // The image drops the basket and tray layers together with the summary rows.
      sync(true);
    });

    sync(true);
  }

  // Pre-built kit bundles: native bundle products. The card image follows the
  // colours picked on the page; "Customize & Add" opens the colour dialog,
  // preset to those colours, and the variant chosen there goes to the cart.
  function initWagonBundles(root) {
    var section = root.querySelector('[data-wagon-bundles]');
    if (!section) return;
    var config = root.querySelector('[data-wagon-config]');
    var track = section.querySelector('[data-bundles-track]');
    var dots = section.querySelector('[data-bundles-dots]');
    var modal = root.querySelector('[data-bundle-modal]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-card]'));
    var activeCard = null;

    function pickedIndex(group) {
      return (config && parseInt(config.getAttribute('data-config-picked-' + group), 10)) || 1;
    }

    function cardData(card) {
      return JSON.parse(card.querySelector('[data-bundle-json]').textContent);
    }

    function optionGroup(name) {
      name = name.toLowerCase();
      return name.indexOf('canopy') >= 0 ? 'canopy' : name.indexOf('basket') >= 0 ? 'basket' : '';
    }

    // Bundle option values share the wagon's colour order, so the picked index maps straight across.
    function pageValues(data) {
      return data.options.map(function (option) {
        var group = optionGroup(option.name);
        var index = group ? pickedIndex(group) : 1;
        return option.values[index - 1] || option.values[0];
      });
    }

    function findVariant(data, values) {
      return data.variants.filter(function (variant) {
        return variant.options.join('|') === values.join('|');
      })[0];
    }

    function syncCards() {
      cards.forEach(function (card) {
        var data = cardData(card);
        var variant = findVariant(data, pageValues(data)) || data.variants[0];
        card.setAttribute('data-bundle-variant', variant.id);
        var image = card.querySelector('[data-bundle-image]');
        if (image && variant.image && image.getAttribute('src') !== variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
        }
      });
    }

    function addToCart(id, button) {
      button.disabled = true;
      button.classList.add('is-adding');
      return postCartItems([{ id: parseInt(id, 10), quantity: 1 }]).then(function () {
        announceCartAdd();
        return true;
      }).catch(function () {
        button.textContent = 'Try again';
        return false;
      }).then(function (ok) {
        button.disabled = false;
        button.classList.remove('is-adding');
        return ok;
      });
    }

    function modalValues() {
      return Array.prototype.map.call(modal.querySelectorAll('.jci-bundle-modal__row'), function (row) {
        var selected = row.querySelector('.is-selected');
        return selected ? selected.getAttribute('data-bundle-value') : '';
      });
    }

    function syncModal() {
      if (!activeCard) return;
      var variant = findVariant(cardData(activeCard), modalValues());
      var add = modal.querySelector('[data-bundle-modal-add]');
      add.disabled = !variant || !variant.available;
      add.textContent = variant && !variant.available ? 'Sold out' : 'Add to Cart';
      modal.setAttribute('data-bundle-variant', variant ? variant.id : '');
    }

    function openModal(card) {
      if (!modal) return;
      activeCard = card;
      var data = cardData(card);
      var values = pageValues(data);
      modal.querySelector('[data-bundle-modal-title]').textContent = card.querySelector('.jci-wagon-bundles__name').textContent.trim();
      modal.querySelector('[data-bundle-modal-price]').innerHTML = card.querySelector('.jci-wagon-bundles__price').innerHTML;
      var rows = modal.querySelector('[data-bundle-modal-options]');
      rows.innerHTML = '';
      data.options.forEach(function (option, index) {
        var row = document.createElement('div');
        row.className = 'jci-bundle-modal__row';
        var label = document.createElement('p');
        label.className = 'jci-bundle-modal__label';
        label.textContent = option.name.replace(/\s*\((.*?)\)/, ' $1');
        row.appendChild(label);
        var list = document.createElement('div');
        list.className = 'jci-bundle-modal__swatches';
        option.values.forEach(function (value) {
          var swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'jci-bundle-modal__swatch' + (value === values[index] ? ' is-selected' : '');
          swatch.setAttribute('data-bundle-value', value);
          // Flat colours from the design; the theme swatch image is only the fallback.
          var swatchKey = value.toLowerCase().replace('forest green', 'moss green');
          var flat = { 'midnight black': '#1d1d1d', 'moss green': '#728976', 'mocha': '#b99d8f', 'sand': '#dfd1c4' }[swatchKey];
          if (flat) swatch.style.background = flat;
          else swatch.setAttribute('data-swatch', swatchKey);
          swatch.setAttribute('aria-label', value);
          swatch.title = value;
          list.appendChild(swatch);
        });
        row.appendChild(list);
        rows.appendChild(row);
      });
      syncModal();
      if (modal.showModal && !modal.open) modal.showModal();
      document.documentElement.classList.add('jci-modal-open');
    }

    function step() {
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    }

    function currentIndex() {
      return Math.round(track.scrollLeft / step());
    }

    function syncDots() {
      if (!dots) return;
      var maxIndex = Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      if (dots.children.length !== maxIndex + 1) {
        dots.innerHTML = '';
        for (var i = 0; i <= maxIndex; i += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'jci-wagon-bundles__dot';
          dot.setAttribute('data-bundles-dot', i);
          dot.setAttribute('aria-label', 'Show bundles ' + (i + 1));
          dots.appendChild(dot);
        }
      }
      var current = Math.min(currentIndex(), maxIndex);
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
      var prev = section.querySelector('[data-bundles-prev]');
      var next = section.querySelector('[data-bundles-next]');
      if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
    }

    section.addEventListener('click', function (event) {
      // A mouse drag ends with a click on whatever is under the pointer; ignore it.
      if (track.hasAttribute('data-twin-dragged')) return;
      var customize = event.target.closest('[data-bundle-customize]');
      if (customize) {
        openModal(customize.closest('[data-bundle-card]'));
        return;
      }
      var more = event.target.closest('[data-bundle-more]');
      if (more) {
        var expanded = more.getAttribute('aria-expanded') !== 'true';
        more.setAttribute('aria-expanded', expanded);
        more.textContent = expanded ? '\u2212' : '+';
        more.closest('[data-bundle-card]').querySelectorAll('[data-bundle-extra]').forEach(function (item) {
          item.hidden = !expanded;
        });
        syncDots();
        return;
      }
      var dot = event.target.closest('[data-bundles-dot]');
      if (dot) {
        track.scrollTo({ left: parseInt(dot.getAttribute('data-bundles-dot'), 10) * step(), behavior: 'smooth' });
        return;
      }
      var direction = event.target.closest('[data-bundles-next]') ? 1 : event.target.closest('[data-bundles-prev]') ? -1 : 0;
      if (direction) track.scrollBy({ left: direction * step(), behavior: 'smooth' });
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        var swatch = event.target.closest('.jci-bundle-modal__swatch');
        if (swatch) {
          swatch.parentNode.querySelectorAll('.jci-bundle-modal__swatch').forEach(function (item) {
            item.classList.toggle('is-selected', item === swatch);
          });
          syncModal();
          return;
        }
        var add = event.target.closest('[data-bundle-modal-add]');
        if (add) {
          var id = modal.getAttribute('data-bundle-variant');
          if (!id) return;
          addToCart(id, add).then(function (ok) {
            if (ok && modal.open) modal.close();
          });
          return;
        }
        // The close buttons, or a click on the backdrop itself.
        if (event.target.closest('[data-bundle-modal-close]') || event.target === modal) modal.close();
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncDots);
    });
    window.addEventListener('resize', syncDots);
    // Card widths settle once fonts and images are in, so count the pages again then.
    window.addEventListener('load', syncDots);
    if (config) root.addEventListener('change', syncCards);
    initDragScroll(track);
    syncCards();
    syncDots();
  }

  // The template-only offer: the discount code lives on the cart, so it survives
  // later adds from any page (verified: discount_codes persist across add/clear).
  function applyTemplateDiscount(root) {
    var code = root.getAttribute('data-v2-discount');
    if (!code || !window.fetch) return;
    if (root.querySelector('[data-canopy-bundle]')) return;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function () {});
  }

  // The accessory page CTA comes from the PreOrder Now app; its per-variant
  // texts are public, so the details dialog reuses them for sold-out variants.
  var preorderSettings = null;
  function loadPreorderSettings(done) {
    if (preorderSettings) return done(preorderSettings);
    var shop = window.Shopify && window.Shopify.shop;
    if (!shop || !window.fetch) return done([]);
    fetch('https://app.preordernowapp.com/get_preloaded_data?shop=' + shop)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        preorderSettings = (data && data.single_product_settings) || [];
        done(preorderSettings);
      })
      .catch(function () {
        preorderSettings = [];
        done(preorderSettings);
      });
  }

  function applyDetailsPreorder(dialog, variantId, isPreorder) {
    var btn = dialog.querySelector('[data-twin-details-add]');
    var note = dialog.querySelector('[data-twin-details-preorder-note]');
    if (!btn) return;
    if (!isPreorder) {
      btn.textContent = 'Add to cart';
      if (note) note.hidden = true;
      return;
    }
    btn.textContent = 'Preorder now';
    loadPreorderSettings(function (list) {
      var productId = dialog.getAttribute('data-twin-details-product');
      var enabled = list.filter(function (item) { return String(item.p) === productId && item.b !== false; });
      var match = enabled.filter(function (item) { return String(item.n) === String(variantId); })[0] ||
        enabled.filter(function (item) { return !item.n; })[0];
      if (!match) return;
      if (match.a) btn.textContent = match.a;
      if (note) {
        note.textContent = match.g || '';
        note.hidden = !match.g;
      }
    });
  }

  function initDetailsPreorder(root) {
    root.querySelectorAll('[data-twin-details-dialog][data-twin-details-preorder="true"]').forEach(function (dialog) {
      applyDetailsPreorder(dialog, dialog.getAttribute('data-twin-details-variant-id'), true);
    });
  }

  // Unpick an accessory: clear its addon input and put the row button back to "Add".
  function resetAddonRow(row) {
    row.querySelectorAll('input[name^="addon["]:checked').forEach(function (input) {
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    row.querySelectorAll('[data-twin-addon-add]').forEach(function (btn) {
      btn.textContent = 'Add';
      btn.classList.remove('is-added');
    });
  }

  function initMobileOrder(root) {
    var buy = root.querySelector('.jci-twin-buy');
    var nodes = [root.querySelector('.jci-twin-reviews'), root.querySelector('.jci-twin-awards')].filter(Boolean);
    if (!buy || !nodes.length) return;

    var anchors = nodes.map(function (node) {
      var anchor = document.createComment('twin-order-anchor');
      node.parentNode.insertBefore(anchor, node);
      return anchor;
    });
    var moved = false;
    var query = window.matchMedia('(max-width: 767px)');

    function apply() {
      if (query.matches && !moved) {
        nodes.forEach(function (node) { buy.appendChild(node); });
        moved = true;
      } else if (!query.matches && moved) {
        nodes.forEach(function (node, index) {
          var anchor = anchors[index];
          anchor.parentNode.insertBefore(node, anchor.nextSibling);
        });
        moved = false;
      }
    }

    apply();
    if (query.addEventListener) query.addEventListener('change', apply);
    else if (query.addListener) query.addListener(apply);
  }

  // Mouse drag scrolls horizontal rows; touch already scrolls natively.
  function initDragScroll(scroller) {
    var startX = 0;
    var startLeft = 0;
    var dragging = false;
    var moved = false;

    function end() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      if (moved) {
        scroller.setAttribute('data-twin-dragged', '');
        window.setTimeout(function () { scroller.removeAttribute('data-twin-dragged'); }, 50);
      }
    }

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startLeft = scroller.scrollLeft;
    });
    scroller.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        scroller.classList.add('is-dragging');
      }
      scroller.scrollLeft = startLeft - dx;
    });
    scroller.addEventListener('pointerup', end);
    scroller.addEventListener('pointerleave', end);
    scroller.addEventListener('pointercancel', end);
  }

  ready(function () {
    var root = document.querySelector('main#content .jci-twin-v2') || document.querySelector('.jci-twin-v2');
    if (!root) return;

    initMobileOrder(root);
    initSticky(root);
    root.querySelectorAll('.jci-twin-questions__pills, .jci-twin-reviews__cards').forEach(initDragScroll);

    initGallery(root);
    initDetailsPreorder(root);
    // Picked accessories go to the cart with the stroller once; clear them after the add.
    document.documentElement.addEventListener('theme:cartchanged', function () {
      root.querySelectorAll('.jci-twin-addons [data-addon-handle]').forEach(resetAddonRow);
    });
    initWagonConfig(root);
    initWagonBundles(root);
    initWagonBundleAtc(root);
    // "close" does not bubble: catch it in the capture phase for every dialog we open.
    root.addEventListener('close', function (event) {
      if (event.target && event.target.tagName === 'DIALOG') document.documentElement.classList.remove('jci-modal-open');
    }, true);
    applyTemplateDiscount(root);
    syncColorLabel(root);
    root.addEventListener('change', function () {
      syncColorLabel(root);
    });

    // Add puts the accessory straight into the cart (Kelsey 11/3). The row's checkbox still decides what that
    // means (colour, single or dual on Waggle): tick it, take the addon inputs it switched on, untick it so the
    // main button won't add them again, then add those lines and open the cart.
    function quickAddAddon(button, checkbox) {
      if (!checkbox || (button && button.disabled)) return;
      // Waggle ticks the basket on its own once a colour or count is picked: start from unticked.
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      var before = Array.prototype.slice.call(root.querySelectorAll('input[name^="addon["]:checked'));
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      var quantities = {};
      Array.prototype.forEach.call(root.querySelectorAll('input[name^="addon["]:checked'), function (input) {
        if (before.indexOf(input) < 0 && input.value) quantities[input.value] = (quantities[input.value] || 0) + 1;
      });
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      var items = Object.keys(quantities).map(function (id) { return { id: Number(id), quantity: quantities[id] }; });
      if (!items.length) return;
      if (button) button.disabled = true;
      postCartItems(items).then(function () {
        if (button) {
          button.textContent = 'Added';
          button.classList.add('is-added');
          window.setTimeout(function () {
            button.textContent = 'Add';
            button.classList.remove('is-added');
          }, 2000);
        }
        announceCartAdd();
      }).catch(function (error) {
        window.alert(error.message);
      }).then(function () {
        if (button) button.disabled = false;
      });
    }

    function handleTwinClick(event) {
      var reviewsTrigger = event.target.closest('[data-twin-open-reviews]');
      if (reviewsTrigger) {
        event.preventDefault();
        event.stopPropagation();
        openTwinReviews(event);
        return;
      }

      var videoBtn = event.target.closest('.jci-twin-video-trigger');
      if (videoBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (videoBtn.hasAttribute('data-twin-video-open')) openVideoDialog(videoBtn);
        return;
      }

      var detailsThumb = event.target.closest('[data-twin-details-thumb]');
      if (detailsThumb) {
        event.preventDefault();
        event.stopPropagation();
        var dialog = detailsThumb.closest('[data-twin-details-dialog]');
        var hero = dialog && dialog.querySelector('.jci-twin-details__hero-img');
        if (hero) {
          // image_tag emits srcset; drop it or the browser keeps the old candidate.
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.src = detailsThumb.getAttribute('data-twin-details-thumb');
        }
        dialog.querySelectorAll('[data-twin-details-thumb]').forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb === detailsThumb);
        });
        return;
      }

      var detailsExpand = event.target.closest('[data-twin-details-expand]');
      if (detailsExpand) {
        event.preventDefault();
        event.stopPropagation();
        var expandDialog = detailsExpand.closest('[data-twin-details-dialog]');
        var expandHero = expandDialog && expandDialog.querySelector('.jci-twin-details__hero-img');
        var lightbox = expandDialog && expandDialog.querySelector('[data-twin-details-lightbox]');
        var lightboxImg = lightbox && lightbox.querySelector('.jci-twin-details__lightbox-img');
        if (expandHero && lightbox && lightboxImg) {
          lightboxImg.src = expandHero.currentSrc || expandHero.src;
          lightboxImg.alt = expandHero.alt || '';
          lightbox.hidden = false;
        }
        return;
      }

      var lightboxClose = event.target.closest('[data-twin-details-lightbox-close]');
      if (lightboxClose) {
        var lightboxBox = lightboxClose.closest('[data-twin-details-lightbox]');
        if (lightboxBox) lightboxBox.hidden = true;
        return;
      }

      var detailsVariant = event.target.closest('[data-twin-details-variant]');
      if (detailsVariant) {
        event.preventDefault();
        var variantDialog = detailsVariant.closest('[data-twin-details-dialog]');
        variantDialog.querySelectorAll('[data-twin-details-variant]').forEach(function (btn) {
          btn.classList.toggle('is-selected', btn === detailsVariant);
        });
        var addTrigger = variantDialog.querySelector('[data-twin-details-add]');
        var variantCheckbox = addTrigger && document.getElementById(addTrigger.getAttribute('data-twin-details-add'));
        if (variantCheckbox) variantCheckbox.value = detailsVariant.getAttribute('data-twin-details-variant');
        var priceEl = variantDialog.querySelector('.jci-twin-details__price');
        var payEl = variantDialog.querySelector('[data-twin-details-pay]');
        if (priceEl) priceEl.textContent = detailsVariant.getAttribute('data-twin-details-price') || priceEl.textContent;
        if (payEl) payEl.textContent = detailsVariant.getAttribute('data-twin-details-installment') || payEl.textContent;
        applyDetailsPreorder(variantDialog, detailsVariant.getAttribute('data-twin-details-variant'), detailsVariant.getAttribute('data-twin-details-preorder') === 'true');
        // A colour with its own photo shows that photo and lights up its thumb.
        var variantImage = detailsVariant.getAttribute('data-twin-details-image');
        var variantHero = variantDialog.querySelector('.jci-twin-details__hero-img');
        if (variantImage && variantHero) {
          variantHero.removeAttribute('srcset');
          variantHero.removeAttribute('sizes');
          variantHero.src = variantImage;
          var mediaId = detailsVariant.getAttribute('data-twin-details-media');
          variantDialog.querySelectorAll('[data-twin-details-thumb]').forEach(function (thumb) {
            var active = thumb.getAttribute('data-twin-details-media') === mediaId;
            thumb.classList.toggle('is-active', active);
            if (active && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        }
        return;
      }

      var lightboxPane = event.target.closest('[data-twin-details-lightbox]');
      if (lightboxPane && event.target === lightboxPane) {
        lightboxPane.hidden = true;
        return;
      }

      var videoClose = event.target.closest('[data-twin-video-close]');
      if (videoClose) {
        closeVideoDialog(videoClose.closest('[data-twin-video-dialog]'));
        return;
      }

      var detailsOpen = event.target.closest('[data-twin-details-open]');
      if (detailsOpen) {
        event.preventDefault();
        event.stopPropagation();
        var dialog = root.querySelector(detailsOpen.getAttribute('data-twin-details-open'));
        if (dialog && dialog.showModal) dialog.showModal();
        document.documentElement.classList.add('jci-modal-open');
        // Open on the colour the card already shows (Waggle basket card).
        var openCard = detailsOpen.closest('[data-addon-handle]');
        var pickedSwatch = openCard && openCard.querySelector('.jci-canopy__swatch.is-picked');
        var pickedInput = pickedSwatch && document.getElementById(pickedSwatch.getAttribute('for'));
        if (dialog && pickedInput) {
          var pickedOption = dialog.querySelector('[data-twin-details-variant="' + pickedInput.value + '"]');
          if (pickedOption && !pickedOption.classList.contains('is-selected')) pickedOption.click();
        }
        // Warm the hero images once so thumb taps swap instantly.
        if (dialog && !dialog.hasAttribute('data-twin-preloaded')) {
          dialog.setAttribute('data-twin-preloaded', '');
          dialog.querySelectorAll('[data-twin-details-thumb]').forEach(function (thumb) {
            var img = new Image();
            img.src = thumb.getAttribute('data-twin-details-thumb');
          });
        }
        return;
      }

      var detailsClose = event.target.closest('[data-twin-details-close]');
      if (detailsClose) {
        var detailsDialog = detailsClose.closest('[data-twin-details-dialog]');
        if (detailsDialog && detailsDialog.open) detailsDialog.close();
        var closeLightbox = detailsDialog && detailsDialog.querySelector('[data-twin-details-lightbox]');
        if (closeLightbox) closeLightbox.hidden = true;
        return;
      }

      var detailsAdd = event.target.closest('[data-twin-details-add]');
      if (detailsAdd) {
        var checkboxId = detailsAdd.getAttribute('data-twin-details-add');
        quickAddAddon(root.querySelector('[data-twin-addon-add="' + checkboxId + '"]'), document.getElementById(checkboxId));
        var addDialog = detailsAdd.closest('[data-twin-details-dialog]');
        if (addDialog && addDialog.open) addDialog.close();
        var addLightbox = addDialog && addDialog.querySelector('[data-twin-details-lightbox]');
        if (addLightbox) addLightbox.hidden = true;
        return;
      }

      var addonAdd = event.target.closest('[data-twin-addon-add]');
      if (addonAdd) {
        event.preventDefault();
        event.stopPropagation();
        quickAddAddon(addonAdd, document.getElementById(addonAdd.getAttribute('data-twin-addon-add')));
        return;
      }

      var crewTab = event.target.closest('[data-twin-crew-tab]');
      if (crewTab) {
        event.preventDefault();
        event.stopPropagation();
        var crewRoot = crewTab.closest('.jci-addons-row');
        if (!crewRoot) return;
        var handles = (crewTab.getAttribute('data-twin-handles') || '')
          .split(',')
          .map(function (handle) { return handle.trim(); })
          .filter(Boolean);
        crewRoot.querySelectorAll('[data-twin-crew-tab]').forEach(function (tab) {
          tab.classList.toggle('is-active', tab === crewTab);
        });
        crewRoot.querySelectorAll('[data-addon-handle]').forEach(function (row) {
          var handle = row.getAttribute('data-addon-handle');
          var match = !handles.length || handles.indexOf(handle) !== -1;
          row.hidden = !match;
          // A hidden row must not ride along with the next add to cart.
          if (!match) resetAddonRow(row);
        });
        return;
      }

      var questionPill = event.target.closest('[data-twin-question]');
      if (questionPill) {
        event.preventDefault();
        event.stopPropagation();
        if (questionPill.closest('[data-twin-dragged]')) return;
        var questions = questionPill.closest('.jci-twin-questions');
        if (!questions) return;
        questions.querySelectorAll('[data-twin-question]').forEach(function (pill) {
          var active = pill === questionPill;
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        var answer = questions.querySelector('[data-twin-question-answer]');
        var source = document.getElementById(questionPill.getAttribute('data-twin-answer-id'));
        if (answer && source) answer.innerHTML = source.innerHTML;
        var pills = questionPill.parentElement;
        pills.scrollTo({
          left: questionPill.offsetLeft - pills.offsetLeft - (pills.clientWidth - questionPill.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    }

    document.addEventListener('click', handleTwinClick, true);

    // Swiping the details hero steps through the thumbs (mobile).
    root.querySelectorAll('.jci-twin-details__hero').forEach(function (hero) {
      var startX = null;
      hero.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
      }, { passive: true });
      hero.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var dialog = hero.closest('[data-twin-details-dialog]');
        var thumbs = dialog ? Array.prototype.slice.call(dialog.querySelectorAll('[data-twin-details-thumb]')) : [];
        if (thumbs.length < 2) return;
        var index = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
        var next = (index + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[next].click();
      }, { passive: true });
    });

    root.querySelectorAll('[data-twin-details-dialog], [data-twin-video-dialog]').forEach(function (dialog) {
      dialog.addEventListener('close', function () {
        var box = dialog.querySelector('[data-twin-details-lightbox]');
        if (box) box.hidden = true;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openLightbox = root.querySelector('[data-twin-details-lightbox]:not([hidden])');
      if (openLightbox) {
        openLightbox.hidden = true;
        event.preventDefault();
        return;
      }
      root.querySelectorAll('dialog[open]').forEach(function (dialog) {
        if (dialog.hasAttribute('data-twin-video-dialog')) closeVideoDialog(dialog);
        else dialog.close();
      });
    });
  });
})();

// Review count follows the Yotpo widget (Katelin 11/3: 92 vs 93 on the Waggle page). The product
// metafield the theme renders lags behind new reviews, so the rating line and the "Read all" link
// take Yotpo's number once its widget has loaded.
(function () {
  var targets = document.querySelectorAll('.jci-twin-rating__text, .jci-twin-reviews__all');
  if (!targets.length) return;
  function apply() {
    var source = document.querySelector('.yotpo-sr-bottom-line-text, .yotpo-bottom-line-basic-text');
    var match = source && source.textContent.match(/(\d[\d,]*)\s+reviews/i);
    if (!match) return false;
    Array.prototype.forEach.call(targets, function (el) {
      el.textContent = el.textContent.replace(/\d[\d,]*(\s+reviews)/i, match[1] + '$1');
    });
    return true;
  }
  if (apply()) return;
  var observer = new MutationObserver(function () {
    if (apply()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 20000);
})();
